import validatePostcodeSelector from 'components/cef_form/PostcodeSelector/validatePostcodeSelector';
import triggerHookFormFieldValidation from 'utils/hook-form/triggerHookFormFieldValidation';

const step3Validation = (hookFormProps, validationFlags) => {
  const { watch, errors, setError, clearErrors, trigger } = hookFormProps;

  const {
    companyType,
    companyNumberLookupSuccess,
    postcodeSearched,
    postcodeIsReset,
    billingAddressMatchesRegistered,
    propertyDuration,
    hasPersistedData,
  } = validationFlags;

  const {
    manualCompanyPostcodeSearched,
    billingPostcodeSearched,
    homePostcodeSearched,
    previousPostcodeSearched,
  } = postcodeSearched;

  const {
    manualCompanyPostcodeIsReset,
    billingPostcodeIsReset,
    homePostcodeIsReset,
    previousPostcodeIsReset,
  } = postcodeIsReset;

  const {
    manualCompanyHasPersistedData,
    billingHasPersistedData,
    homeHasPersistedData,
    previousHasPersistedData,
  } = hasPersistedData;

  const mainRouteValidation = [
    {
      prefix: 'manualCompany',
      searched: manualCompanyPostcodeSearched,
      clearFieldErrors: companyNumberLookupSuccess,
      // Only clear the error on the searchPostcode field if postcode selector component has not been reset
      // Because the postcode lookup is reset if persisted data is present and it shouldn't block going to the next step
      clearPostcodeSearchErrors: manualCompanyPostcodeIsReset
        ? false
        : manualCompanyHasPersistedData,
    },
    {
      prefix: 'billing',
      searched: billingPostcodeSearched,
      clearFieldErrors: billingAddressMatchesRegistered,
      // Only clear the error on the searchPostcode field if postcode selector component has not been reset
      // Because the postcode lookup is reset if persisted data is present and it shouldn't block going to the next step
      clearPostcodeSearchErrors: billingPostcodeIsReset
        ? false
        : billingHasPersistedData,
    },
  ];

  const soleTraderRouteValidation = [
    {
      prefix: 'home',
      searched: homePostcodeSearched,
      // Only clear the error on the searchPostcode field if postcode selector component has not been reset
      // Because the postcode lookup is reset if persisted data is present and it shouldn't block going to the next step
      clearPostcodeSearchErrors: homePostcodeIsReset
        ? false
        : homeHasPersistedData,
    },
    {
      prefix: 'previous',
      searched: previousPostcodeSearched,
      clearFieldErrors: propertyDuration,
      // Only clear the error on the searchPostcode field if postcode selector component has not been reset
      // Because the postcode lookup is reset if persisted data is present and it shouldn't block going to the next step
      clearPostcodeSearchErrors: previousPostcodeIsReset
        ? false
        : previousHasPersistedData,
    },
  ];

  const postcodeSelectorValidations = {
    0: mainRouteValidation, // LC
    1: soleTraderRouteValidation, // Sole Trader
    5: mainRouteValidation, // LLP
    6: mainRouteValidation, // PLC
  };

  const validate = async () => {
    // Validate the postcode selector fields
    const postcodeValidationConfig = postcodeSelectorValidations[companyType];

    const postcodeFieldsValid = validatePostcodeSelector(
      postcodeValidationConfig,
      watch,
      errors,
      setError,
      clearErrors,
    );

    // Trigger the validation on the radio groups
    const radioFieldsValid = await triggerHookFormFieldValidation(trigger, [
      'addresses.1.own',
      'addresses.1.more_than_3_years',
    ]);

    return postcodeFieldsValid && radioFieldsValid;
  };

  return validate;
};

export default step3Validation;
